import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class DeskWrap extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
    }

    render() {
        const { children } = this.props

        return <div className={'toolbar-desk-wrap'}>{children}</div>
    }
}
